var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9869 2.97357L7.33354 5.48024C5.80021 6.05357 4.54688 7.86691 4.54688 9.49357V19.4002C4.54688 20.9736 6.85354 23.9869 6.85354 23.9869C6.85354 23.9869 10.7069 28.1869 12.5869 29.6002C14.4669 31.0136 17.5602 31.0136 19.4402 29.6002C21.3202 28.1869 25.1735 23.9869 25.1735 23.9869C25.1735 23.9869 27.4802 20.9736 27.4802 19.4002V9.49357C27.4802 7.85357 26.2269 6.04024 24.6935 5.46691C23.1602 4.89357 19.1735 3.38691 18.0402 2.97357C16.9069 2.56024 15.0935 2.56024 13.9869 2.97357Z",
    fill: "#EE1C29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1705L14.5426 18.6667L21.3333 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.eeeda68f.svg";
export { ForwardRef as ReactComponent };